var _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarrefourLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 41,
    viewBox: "0 0 45 41",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9402 1.29934C20.8628 1.65815 19.8353 2.15348 18.8824 2.77338C13.5533 6.10723 11.1658 12.2248 10.9243 18.1472C10.9077 18.4853 10.9053 18.8211 10.9053 19.1545C10.9053 19.1854 10.9053 19.3569 10.9053 19.414V40.4554H17.8379V19.4188C17.8357 18.1427 18.3992 16.9319 19.3751 16.1159L22.1107 19.4188L24.8416 16.1183C25.8177 16.9333 26.382 18.1431 26.3811 19.4188V40.4602H33.3113V19.4188C33.316 15.6833 31.478 12.1886 28.4047 10.0896C25.3314 7.99048 21.4228 7.56024 17.9705 8.941C19.3916 7.27408 21.5233 6.43347 23.8776 6.38346C24.6277 6.36795 25.3775 6.42778 26.1158 6.56206C32.2502 7.57174 36.9233 12.7535 36.947 18.9759C36.947 19.214 36.9636 19.4522 36.9636 19.6903V40.4459H43.8985V19.5307C43.8985 10.465 38.4794 3.19726 29.2446 1.03264C28.9083 0.954053 28.373 0.846894 27.8946 0.782598C27.1971 0.680541 26.4937 0.624856 25.789 0.615906C24.4762 0.616107 23.1736 0.847413 21.9402 1.29934Z",
    fill: "#0E5AA7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6673 0.213501C8.49885 0.213501 0 8.34189 0 19.1311V40.4562H7.06188C7.06188 40.4562 7.06188 28.725 7.06188 19.1144C7.06188 9.0854 14.7338 1.93003 22.4346 0.378459C22.748 0.31152 23.1145 0.213501 22.748 0.213501L20.6673 0.213501Z",
    fill: "#EE2527"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3619_718",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 41
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6673 0.213501C8.49885 0.213501 0 8.34189 0 19.1311V40.4562H7.06188C7.06188 40.4562 7.06188 28.725 7.06188 19.1144C7.06188 9.0854 14.7338 1.93003 22.4346 0.378459C22.748 0.31152 23.1145 0.213501 22.748 0.213501L20.6673 0.213501Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3619_718)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarrefourLogo);
export default __webpack_public_path__ + "static/media/carrefour-logo.5e31fe57599288b99fd952f751f05e51.svg";
export { ForwardRef as ReactComponent };